var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkativIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6CE6F9;}\n\t.st1{fill:#466AF3;}\n\t.st2{fill:#5B9FF7;}\n\t.st3{fill:#314AF2;}\n\t.st4{opacity:0.75;fill:#FFFFFF;enable-background:new    ;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9650",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9648",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4786",
    className: "st0",
    d: "M6.9,0.3C3.2,1.1,0.5,4.3,0.1,8C1.9,7.3,5.2,5.4,6.9,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4787",
    className: "st1",
    d: "M8.9,18c2.2-2.6,5.1-4.4,8.3-5.3C17.7,11.6,18,10.3,18,9c0-2.8-1.3-5.5-3.6-7.2 c0.4,7.4-6.3,8.9-10.8,10.9c-0.8,0.3-1.5,0.8-2.2,1.2C3.1,16.5,5.9,18,8.9,18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4788",
    className: "st2",
    d: "M14.4,1.8C12.9,0.6,11,0,9,0C8.3,0,7.6,0.1,6.9,0.3C5.9,3.8,3.4,6.6,0.1,8C0,8.4,0,8.7,0,9 c0,1.8,0.5,3.5,1.5,5c0.7-0.5,1.4-0.9,2.2-1.2C8.1,10.7,14.8,9.3,14.4,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4789",
    className: "st3",
    d: "M8.9,18H9c3.5,0,6.7-2.1,8.2-5.3C14,13.6,11.1,15.4,8.9,18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9649",
    transform: "translate(6.47 7.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4790",
    className: "st4",
    d: "M2.5,7.4c0,0.7-0.5,1.3-1.2,1.3C0.6,8.7,0,8.2,0,7.5c0,0,0,0,0-0.1V1.2C0,0.6,0.6,0,1.3,0 c0.7,0,1.2,0.5,1.2,1.2V7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4791",
    className: "st4",
    d: "M11.1,7.4c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.5-1.2-1.2V5c0-0.7,0.6-1.2,1.3-1.2 c0.7,0,1.2,0.5,1.2,1.2V7.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_534",
    className: "st5",
    cx: 9.8,
    cy: 1.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4792",
    className: "st5",
    d: "M10.7,6.5c0.5,0.5,0.5,1.3,0,1.8c-0.5,0.5-1.3,0.5-1.7,0L6.1,5.3C5.8,5,5.3,5,5,5.3 c0,0,0,0,0,0L2.1,8.3c-0.5,0.5-1.3,0.5-1.8,0c-0.5-0.5-0.5-1.3,0-1.7l4.2-4.4c0.5-0.5,1.3-0.5,1.8,0c0,0,0,0,0,0L10.7,6.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkativIcon);
export default __webpack_public_path__ + "static/media/workativ_icon.688a783eedd9be9ce7b0c695d9efb772.svg";
export { ForwardRef as ReactComponent };